import React, { useEffect, useState } from 'react'
import { NavLink, useLocation, Link } from 'react-router-dom';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // const isAboutPage = location.pathname === '/About-Us';
  // const isServicesPage = location.pathname === '/Service';

  const headerStyledRoutes = [
    '/About-Us',
    '/Service',

    '/Software-Development',
    '/Cyber-Security',
    '/QA-Services',
    '/Cloud-Services',
    '/Artificial-Intelligence',

    '/Careers',

    '/BlogPage',
    '/Services-Details',
    '/Blog',
    '/Contact-Us'
  ];
  const applyStyledHeader = headerStyledRoutes.includes(location.pathname);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setScrolled(offset > 50); // Adjust value to your needs
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (

    <header className={`container-fluid ${applyStyledHeader ? 'about-navbar' : ''}`}>
      <nav className={`navbar navbar-expand-lg container-fluid ${applyStyledHeader ? 'about-navbar' : ''}`}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <NavLink className="navbar-brand" to={'/'} aria-label="Open navigation menu">
            <img src="../assets/images/Logo.webp" className="headlogo" alt="4Sighttech logo" />
            {/* <h3 className='logo-head'>4SIGHT TECH</h3> */}
          </NavLink>
        </div>

        <button className="navbar-toggler custommenu-iconbt" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" >
          {/* <span class="navbar-toggler-icon"></span> */}
          <img className='custommenu-icon' src='../assets/images/mobileicons.png' alt='menu icon' />
        </button>

        <div className="collapse navbar-collapse cstmtest" id="navbarSupportedContent">
          <ul className="navbar-nav mx-auto custom-header">
            <li className="nav-item">
              <NavLink className="nav-link active" to={'/'}>Home</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to={'/About-Us'}>About Us</NavLink>
            </li>
            {/* <li className="nav-item dropdown">
              <div className="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Services
              </div>
              <ul className="dropdown-menu drop-bg" aria-labelledby="navbarDropdown">
                <li><NavLink className="dropdown-item" to={''}>Service 1</NavLink></li>
                <li><NavLink className="dropdown-item" to={''}>Service 2</NavLink></li>
                <li><NavLink className="dropdown-item" to={''}>Service 3</NavLink></li>
                <li><NavLink className="dropdown-item" to={''}>Service 4</NavLink></li>
                <li><NavLink className="dropdown-item" to={''}>Service 5</NavLink></li>
                <li><NavLink className="dropdown-item" to={''}>Service 6</NavLink></li>
                <li><NavLink className="dropdown-item" to={''}>Service 7</NavLink></li>
              </ul>
            </li> */}
            <li className="nav-item">
              <Link className="nav-link" to={'/Service'}>Services</Link>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to={'/Blog'}>Blog</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to={'/Careers'}>Careers</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to={'/Contact-Us'}>Contact Us</NavLink>
            </li>

          </ul>
          <div className="form-inline my-2 my-lg-0 d-flex" style={{ alignItems: 'center' }}>
            <div className='header-rightsec'>
              <div className='header-rightsecbox'>
                <img className='header-rightim' src='../assets/images/CallIcon.png' alt='header call icon' />
                <div>
                  <p className='header-righttxt'>Have Any Questions?</p>
                  <h3 className='header-rightsubtxt'>+1 945-419-8003</h3>
                </div>
              </div>
              <NavLink style={{ textDecoration: 'none' }} to={'/Contact-Us'}>
                <button className="startbt">Get Free Quote</button>
              </NavLink>
            </div>
          </div>
        </div>
      </nav>
    </header>
  )
}

export default Header;